import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  viewer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  toolbar: {
    position: 'absolute',
    top: 0,
    height: 48,
    width: '100%',
    background: '#212121',
    zIndex: 1001,
    padding: '0 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  frame: {
    position: 'absolute',
    top: 48,
    width: 'calc(100% - 64px)',
    height: 'calc(100% - 64px)',
    left: 32,
    border: 'none',
    borderRadius: 4,
    background: '#eee',
  },

  hiddenFrame: {
    visibility: 0,
    height: 0,
  },
  toolbarButton: {
    verticalAlign: 'middle',
    padding: 0,
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',

    '&:focus': {
      outline: 'none',
    },
  },

  toolbarIcon: {
    width: '42px !important',
    height: '34px !important',
    padding: '4px 6px',
    '&:hover': {
      color: '#fff',
    },
  },

  backButton: {
    display: 'flex',
    alignItems: 'center',
  },
  iconButton: {
    marginLeft: 12,
    color: '#BDBDBD',
    '& a': { color: '#BDBDBD', width: 20, height: 20 },
  },
  failed: {
    color: '#000',
    fontWeight: 'bold',
  },
});
